import React from "react";
import PropTypes from "prop-types";

// The outlet card's own pills. SourceBadges carries a closed set of person-oriented variants
// (Fast to Respond, Qwoted 100, …); prestige tier and outlet classification are outlet-only and
// live here rather than widening that shared set.
const PRESTIGE_LABELS = {
  tier1: "Tier 1",
  tier2: "Tier 2",
};

const CLASSIFICATION_LABELS = {
  trade: "Trade",
  podcast: "Podcast",
};

const pillStyle = (background, color) => ({
  display: "inline-flex",
  alignItems: "center",
  background,
  color,
  fontSize: 11,
  fontWeight: 700,
  padding: "3px 9px",
  borderRadius: 999,
  letterSpacing: "0.22px",
  lineHeight: 1.3,
  whiteSpace: "nowrap",
});

// The base tier and the standard classification are the defaults every outlet starts at, so they
// carry no information worth a pill.
function OutletBadges({ prestige, outletClassification, marginTop = 6 }) {
  const prestigeLabel = PRESTIGE_LABELS[prestige];
  const classificationLabel = CLASSIFICATION_LABELS[outletClassification];
  if (!prestigeLabel && !classificationLabel) return null;

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop }}>
      {prestigeLabel && <span style={pillStyle("#edeafa", "#3a27a5")}>{prestigeLabel}</span>}
      {classificationLabel && <span style={pillStyle("#eef1f3", "#4d5357")}>{classificationLabel}</span>}
    </div>
  );
}

OutletBadges.propTypes = {
  prestige: PropTypes.string,
  outletClassification: PropTypes.string,
  marginTop: PropTypes.number,
};

export default OutletBadges;
